var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInsights = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  viewBox: "0 0 22 20",
  fill: "currentColor",
  stroke: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Insights",
  transform: "translate(-1 -2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2621",
  "data-name": "Path 2621",
  d: "M12,22a1,1,0,0,1-1-1V16a1,1,0,0,1,2,0v5A1,1,0,0,1,12,22Z",
  fill: "inherit"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2622",
  "data-name": "Path 2622",
  d: "M16,22a1,1,0,0,1-1-1V14a1,1,0,0,1,2,0v7A1,1,0,0,1,16,22Z",
  fill: "inherit"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2623",
  "data-name": "Path 2623",
  d: "M20,22a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V21A1,1,0,0,1,20,22Z",
  fill: "inherit"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2624",
  "data-name": "Path 2624",
  d: "M2,16a1,1,0,0,1-.707-1.707L7.94,7.647a1.5,1.5,0,0,1,2.121,0L13,10.586l8.293-8.293a1,1,0,0,1,1.414,1.414l-8.646,8.646a1.5,1.5,0,0,1-2.123,0L9,9.415,2.707,15.707A1,1,0,0,1,2,16Z",
  fill: "inherit"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2625",
  "data-name": "Path 2625",
  d: "M4,22a1,1,0,0,1-1-1V18a1,1,0,0,1,2,0v3A1,1,0,0,1,4,22Z",
  fill: "inherit"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2626",
  "data-name": "Path 2626",
  d: "M8,22a1,1,0,0,1-1-1V14a1,1,0,0,1,2,0v7A1,1,0,0,1,8,22Z",
  fill: "inherit"
}))));
export { SvgInsights as ReactComponent };
export default __webpack_public_path__ + "static/media/insights.fdbf146844b8b315606a8d4d50b95bf5.svg";